import React from 'react'
import { Modal, Button, Message } from 'semantic-ui-react'
import { dispatch } from '@rematch/core';
import LoadingComponent from "./../../../../common/LoadingComponent";
import ModalFooter from './../../../../drive/ModalFooter'
import { Form } from 'formsy-semantic-ui-react';
import { singleLineText } from './../../../../common/RegexValidation';
import ImageAvater from '../../../../drive/Components/ImageAvater';
import Labels from '../../../../common/Labels';

class InviteUserModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            setRole: 'user',
            inviteUserError: ''
        }
        this.handleChange = this.handleChange.bind(this);
        this.onSubmitInviteUser = this.onSubmitInviteUser.bind(this);
    }

    close = () => {
        this.props.setInviteUserModal(false);
        this.setState({ inviteUserError: '' })
        dispatch.invite.addedAccountUserData(null)
    }
    componentWillMount() {
        dispatch.invite.addedAccountUserData(null)
    }

    handleChange(data) {
        this.setState({ setRole: data.target.value })
    }

    // This function is for Further Development as when the user search
    // By an email Id so check the invited used present in list ans show 
    // In table. Need to add table and data for search email result
    handleOnchange = (e, data) => {
        this.setState({
            [data.name]: data.value
        });
    }

    async onSubmitInviteUser(formData) {

        formData.role = this.state.setRole;
        formData.from = this.props.user._id;
        formData.accountId = this.props.selectedAccount._id;
        formData.referenceId = this.props.selectedAccount._id;
        formData.referenceCollection = 'accounts';
        if (this.props.invitedIn === "platform") {
            formData.role = 'platformAdmin';
        }
        try {
            await dispatch.invite.sendInviteByAccountAsync(formData);
            if (this.props.addedAccountUser === null) {
                this.props.setInviteUserModal(false);
            }
            this.setState({ setRole: 'user' })
        }
        catch (err) {
            this.setState({ inviteUserError: err })
        }
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;

        return (
            <Modal
                className="basicModal"
                open={this.props.open}
                size='mini'
                onClose={this.close}
                closeOnEscape={true}
                closeOnDimmerClick={false}
                closeIcon
            >
                <LoadingComponent active={this.props.InviteUserLoader} message="Loading..." />
                <Modal.Header>
                    {this.props.selectedAccount.isPlatformAccount === true ? 'Invite Platform User' : 'Invite User'}
                </Modal.Header>

                <Modal.Content className="pad_20">

                    <Form noValidate
                        error
                        ref={ref => this.form = ref}
                        onValidSubmit={this.onSubmitInviteUser}
                        id="inviteUser">

                        <Form.Input
                            required
                            name="firstName"
                            id="firstName"
                            label="First Name"
                            errorLabel={errorLabel}
                            validations={{ matchRegexp: singleLineText }}
                            validationErrors={{
                                matchRegexp: 'Max limit is 128.No numbers or special characters allowed. No space allowed in starting.',
                                isDefaultRequiredValue: 'First name is required',
                            }}
                            instantValidation
                            autoFocus
                        />

                        <Form.Input
                            name="lastName"
                            id="lastName"
                            label="Last Name"
                            required
                            errorLabel={errorLabel}
                            validations={{ matchRegexp: singleLineText }}
                            validationErrors={{
                                matchRegexp: 'Max limit is 128.No numbers or special characters allowed. No space allowed in starting.',
                                isDefaultRequiredValue: 'Last Name is required',
                            }}
                            instantValidation
                        />
                        <Form.Input
                            name="email"
                            id="email"
                            label="Email"
                            icon="envelope"
                            iconPosition="left"
                            required
                            validations="isEmail"
                            errorLabel={errorLabel}
                            validationErrors={{
                                isEmail: 'This is not a valid email',
                                isDefaultRequiredValue: 'Email is required',
                            }}
                            onChange={this.handleOnchange}
                            instantValidation
                        />
                        {this.props.invitedIn === "account" ?
                            <Form.Field
                                placeholder='Role'
                                id='Role'
                                label='Role'
                                control='select'
                                onChange={this.handleChange}
                                defaultValue={"user"}
                            >
                                <option style={{ color: "#cccccc" }} disabled value='customerAdmin'>Customer Admin</option>
                                <option style={{ color: "#cccccc" }} disabled value='billingAdmin'>Billing Admin</option>
                                <option value='user'>User</option>

                            </Form.Field> :
                            <Labels name="Role" text="Platform User" />
                        }

                        {this.state.inviteUserError && this.state.inviteUserError.code === 409 ?
                            <Message
                                error
                                content="Invitation is already sent to this e-mail address."
                            />
                            : this.state.inviteUserError && this.state.inviteUserError.message ?
                                <Message
                                    error
                                    content={this.state.inviteUserError.message}
                                /> : ''}
                        {this.props.addedAccountUser !== null ?
                            <Message error>
                                <Message.Header>User with same e-mail already exists.</Message.Header>
                                <p>
                                    <ImageAvater user={this.props.addedAccountUser} />
                                    <span>{this.props.addedAccountUser.firstName + ' ' + this.props.addedAccountUser.lastName}</span>
                                    <br />
                                    <span>{this.props.addedAccountUser.role && this.props.addedAccountUser.role === 'user' ? 'Account User'
                                        : this.props.addedAccountUser.role === 'customerAdmin' ? 'Customer Admin'
                                            : this.props.addedAccountUser.role === 'platformAdmin' ? 'Platform User' : ''}
                                    </span>
                                    <br />
                                    <span>{this.props.addedAccountUser.email} </span>
                                </p>
                            </Message>
                            : ''}
                        <Modal.Actions className="actionInFormcy border-none pad_0" style={{ "text-align": "right" }}>
                            <Button content='Invite' className="button-submit float-right" type="submit" />
                            <Button content="Cancel" className="button-cancel" type="button" onClick={this.close} />
                        </Modal.Actions>

                    </Form>
                </Modal.Content>

                <ModalFooter />
            </Modal>
        )
    }
}

export default InviteUserModal;